export const TILE_SIZE_METERS = 1280;
export const VISUAL_REVEAL_RADIUS_METERS = 500_000;

const EARTH_RADIUS_M = 6_371_000;

export function lngLatToMercatorMeters(lng: number, lat: number): [number, number] {
    const clampedLat = Math.max(Math.min(lat, 89.9), -89.9);
    const x = (lng * Math.PI * EARTH_RADIUS_M) / 180;
    const y = Math.log(Math.tan(Math.PI / 4 + (clampedLat * Math.PI) / 360)) * EARTH_RADIUS_M;
    return [x, y];
}
